import React from 'react'

const ThemeSpinner = () => {
    return (
        <div className="theme-spinner"></div >
    )
}

export default ThemeSpinner